import { adaptV4Theme, createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

export const errorTheme = createTheme(adaptV4Theme({
  palette: {
    primary: red,
  },
}));